import React from 'react';
import { createPortal } from 'react-dom';

const Portal: React.FC<{ component }> = ({ component }) => {
  return createPortal(component, document.querySelector('#portal'));
};
export default Portal;
